import React from 'react';
import PropTypes from 'prop-types';
import { EuiSuperSelect } from '@elastic/eui';

export const ComboSimple = (props) =>{

  let propiedades = {
    options:props.options ? props.options : [],
    valueOfSelected: props.valueOfSelected || undefined,
    isInvalid: props.isInvalid,
    disabled: props.disabled,
    isLoading: props.disabled || props.options  ? false : true,
    compressed: props.compressed!== undefined ? props.compressed : false
  }

  return (
    <EuiSuperSelect {...{...props,...propiedades}}/>
  )
}
export default ComboSimple